import { queryGraphQL, mutateGraphQL } from 'common/util/query';
import { toMutation, toQuery, nodeWithArgs, node } from 'common/util/queryHelper';
import { addApplicationMessage } from 'common/actions/applicationMessagesActions';
import lodash from 'lodash';

import DoAExport from 'pages/delegationOfAuthority/containers/DoAExport';
import { getTimezoneOffset } from 'common/selectors/index';
import {
    delegationsList,
} from 'pages/delegationOfAuthority/selectors';
import { isCentralized } from 'pages/delegationOfAuthority/selectors';
import { doaDataSelector } from '../selectors/studyAuditLog';
import DelegationAuditLog from '../util/DelegationAuditLog';
import DelegationSummary from '../util/DelegationSummary';
import Export from '../util/Export';

import { binderInstitutionIdSelector } from 'common/selectors';

export const WRITE_DELEGATION_AUDIT_LOG_DATA = 'WRITE_DELEGATION_AUDIT_LOG_DATA';

export function retrieveStudyAuditLogData(binderId) {
    return async (dispatch, getState) => {
        const institutionId = binderInstitutionIdSelector(getState());
        const query = nodeWithArgs('retrieveStudyAuditLogData', {
            institutionId,
            binderId,
        }, [
            node('auditLogEntries', [
                'id',
                'actionUserDisplayName',
                'actionType',
                'assetId',
                'value',
                'notes',
                'createdAt'
            ]),
            node('auditLogUsers', [
                'id',
                'displayName',
            ]),
        ]);

        const response = await queryGraphQL(toQuery(query));
        if (response.errors) {
            return dispatch(addApplicationMessage('error', 'An error occurred when loading the DOA audit log.'));
        }
        const auditLogData = response.data.retrieveStudyAuditLogData;
        if (auditLogData.length === 0) {
            return dispatch(addApplicationMessage('warning', 'An error occurred when loading the DOA audit log.'));
        }

        dispatch(retrieveStudyAuditLogDataAction(auditLogData));
    };
}

export function retrieveStudyAuditLogDataAction(auditLogData) {
    return {
        type: WRITE_DELEGATION_AUDIT_LOG_DATA,
        payload: auditLogData,
    };
}

export function generateExport(institutionId, binderId) {
    return async dispatch => {
        const query = nodeWithArgs('exportDoALog', {
            institutionId,
            binderId,
        });

        const {
            errors,
        } = await mutateGraphQL(toMutation(query));

        if(errors) {
            return dispatch(addApplicationMessage('error', 'An error occurred while generating the export'));
        }

        return dispatch(loadAuditLogDataAndGenerateExport(institutionId, binderId));
    };
}

function loadAuditLogDataAndGenerateExport(institutionId, binderId) {
    return async (dispatch, getState) => {
        const query = nodeWithArgs('retrieveStudyAuditLogData', {
            institutionId,
            binderId,
        }, [
            node('auditLogEntries', [
                'id',
                'actionUserDisplayName',
                'actionType',
                'assetId',
                'value',
                'notes',
                'createdAt'
            ]),
            node('auditLogUsers', [
                'id',
                'displayName',
            ]),
        ]);

        const {
            data: {
                retrieveStudyAuditLogData: auditLogData
            },
            errors,
        } = await queryGraphQL(toQuery(query));

        if (errors) {
            return dispatch(addApplicationMessage('error', 'An error occurred when loading the DOA audit log.'));
        }

        const state = getState(); 
        const timezoneOffset =  getTimezoneOffset(state);
        const DOAData = doaDataSelector(state, auditLogData.auditLogEntries, auditLogData.auditLogUsers);


        const pdfExport = new Export();
        pdfExport.register(new DelegationSummary(DOAData, timezoneOffset));
        pdfExport.register(new DelegationAuditLog(DOAData, timezoneOffset));
        const exportFileName = `${DOAData.studyBinder.title}-delegation-log`;
        pdfExport.generate(exportFileName);

    };
}

export function exportAuditLog(institutionId, binderId) {
    return (dispatch, getState) => {
        const query = nodeWithArgs('exportDoALog', {
            institutionId,
            binderId,
        });
        return mutateGraphQL(toMutation(query)).then(results => {
            if (results && results.errors) {
                dispatch(addApplicationMessage('error', 'Failed to export log'));
            }

            const state = getState();
            const timezoneOffset =  getTimezoneOffset(state);
            const doaStudyTasks = lodash.get(state, 'doaStudyTasks', []);
            const doaStudyDelegations = delegationsList(state);
            const binder = lodash.get(state, 'binder', {});
            const testaments = lodash.get(state, 'doaTestaments', []);
            const isCentralizedInstitution = isCentralized(state);

            const exportLog = new DoAExport(timezoneOffset, doaStudyTasks, doaStudyDelegations, binder, testaments, isCentralizedInstitution, state);
            exportLog.exportDOALog();
        });
    };
}